import React from "react";
import { DPRestrictedPage } from "Components/DP";
import { HelpText } from "Components/Shared/HelpText/HelpText";
import { Grid, Typography } from "@material-ui/core";
import { usePartnerConfig } from "Hooks/usePartnerConfig";
import { BalanceDistributorTable } from "./BalanceDistributorTable/BalanceDistributorTable";
import { PageNotFound } from "..";
import { BalanceDistributorActions } from "./BalanceDistributorActions/BalanceDistributorActions";
import useStyles from "./styles";

export const BalanceDistributorReport = () => {
  const classes = useStyles();
  const { enabledFeatures, permissions, balanceDistributorOptions } = usePartnerConfig();

  const hidePage = enabledFeatures.indexOf("provider_balance_distributor_report") === -1 ||
    !permissions.canViewPayrollExtenderReports ||
    !balanceDistributorOptions?.enabled;

  if (hidePage) {
    return (
      <PageNotFound />
    );
  }

  return (
    <DPRestrictedPage title="Balance Distributor" permissionKey="canViewReports">
      <Grid container spacing={2}>
        <HelpText>
          <b>What is the Balance Distributor Report?</b> A list of all users who received remainder payments on a weekly basis.
        </HelpText>
        <BalanceDistributorActions />
        <Grid item xs={12}>
          <Typography variant="h3" className={classes.tableTitle}>
          Balance Distributor Report
          </Typography>
          <BalanceDistributorTable />
        </Grid>
      </Grid>
    </DPRestrictedPage>
  );
};
